import type { FC } from 'react';
import { Capacitor } from '@capacitor/core';

import { AppleWalletButton } from '../AppleWalletButton/AppleWalletButton';
import { GoogleWalletButton } from '../GoogleWalletButton/GoogleWalletButton';

export interface IAddToWalletButtonsProps {
	ticketId: string;
}

export const AddToWalletButtons: FC<IAddToWalletButtonsProps> = ({
	ticketId,
}) => {
	const platform = Capacitor.getPlatform();

	if (platform === 'web') {
		return null;
	}

	if (platform === 'ios') {
		return <AppleWalletButton ticketId={ticketId} />;
	}

	if (platform === 'android') {
		return <GoogleWalletButton ticketId={ticketId} />;
	}

	return null;
};
